/**
 */

import React from 'react';

export const Dependency = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4.06895"
      y="4.16782"
      width="4.27961"
      height="4.27961"
      rx="1.1"
      stroke={color || '#000'}
      strokeWidth="1.8"
    />
    <rect
      x="8.52891"
      y="8.62803"
      width="4.27961"
      height="4.2796"
      rx="1.1"
      stroke={color || '#000'}
      strokeWidth="1.8"
    />
    <rect
      x="12.9889"
      y="13.0882"
      width="4.27961"
      height="4.27961"
      rx="1.1"
      stroke={color || '#000'}
      strokeWidth="1.8"
    />
  </svg>
);
